import {isString, reduce} from 'lodash';
import { WidgetAttributes } from './widget-attributes';
import { ILpWidget, IWidget, ILpCoreUtils, ILpCoreTemplate, ILpCoreBus } from './launchpad';

export class EvoGenericWidget {

    constructor(public id: string,
        public attributes: WidgetAttributes,
        public widgetRoot: string,
        public type: string,
        public props: {
            [key: string]: string,
        } = {},        
        public htmlNode?: HTMLElement,
        public order?: Number,
        public serverRoot?: string,
        public shownByDefault: boolean = false
        ) {
        
    }

    public getLPWidgetInstance(): ILpWidget {
        return Object.create({
            getPreference: this.getPreference.bind(this),
            getResolvedPreference: this.getResolvedPreference.bind(this)
        });
    }

    public getWidgteInstance(): IWidget {
        return Object.create( {
            getPreference: this.getPreference.bind(this),
            getResolvedPreference: this.getResolvedPreference.bind(this)
        });
    }

    public getLpCoreBusInstance(): ILpCoreBus {
        return Object.create( {
            publish: (<any>window).gadgets.pubsub.publish,
            subscribe: (<any>window).gadgets.pubsub.subscribe,
            unsubscribe: (<any>window).gadgets.pubsub.publish,
            flush: (<any>window).flush
        });
    }

    public getLpCoreTemplateInstance(): ILpCoreTemplate {
        return Object.create({
            resolvePath: this.resolvePath.bind(this)
        });
    }

    private getResolvedPreference(key: string): string {
        const preference = this.getPreference(key);
        return this.resolvePortalPlaceholders(preference);
    }

    private getPreference(key: string): string {
        return this.props[key];
    }

    private resolvePortalPlaceholders(str: string): string {
        if (isString(str)) {
        let replacements: Array<string> = ["$(contextRoot)", "$(contextPath)", "$(servicesPath)"];
            str = reduce(replacements, function (value: string, replace: string): string {
                return value.replace(replace, (<any>window).b$.portal.config.serverRoot || '/portalserver2');
            }, str);
        }
        return str;
    }

    private resolvePath(str: string): string {
        let url = (<any>window).b$.portal.config.serverRoot + '/static/deutsche-bank-ui/widgets/' + this.attributes.appBundleName;
        return url.split("/").slice(0, url.split("/").length - 1).join("/") + "/" + str;
    }
}

